"use client";

import { useState } from "react";
import { ProofShowcase, type ProofShowcaseCopy } from "./ProofShowcase";

type ProofInteractiveDemoProps = {
  copy: {
    showcase: ProofShowcaseCopy;
  };
};

export function ProofInteractiveDemo({ copy }: ProofInteractiveDemoProps) {
  const [showFullExample, setShowFullExample] = useState(false);

  return (
    <>
      <ProofShowcase copy={copy.showcase} compact={!showFullExample} />
      <div className="mt-4 flex justify-center">
        <button
          type="button"
          aria-expanded={showFullExample}
          aria-controls="full-lesson-example"
          onClick={() => setShowFullExample((current) => !current)}
          className="inline-flex min-h-11 items-center justify-center rounded-full border border-green-300 bg-white px-5 text-sm font-black text-green-800 transition-colors hover:bg-green-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700"
        >
          {showFullExample ? "Hide full lesson example" : "View full lesson example"}
        </button>
      </div>
    </>
  );
}
